const PREFIX = process.env.VUE_APP_API;

export default {
  evaluation: `${PREFIX}/api/management/evaluations`,
  evaluationId: id => `${PREFIX}/api/management/evaluations/${id}`
};
